import React from 'react';
import PropTypes from 'prop-types';

const getZeldaBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'https://admin.localhost';
  }
  const isStaging = window.location.hostname.includes('staging');
  return isStaging ? 'https://team.staging-pathstream.com' : 'https://team.path.stream';
};

const BlockEditInZeldaPlaceholder = ({ block, bootcampId }) => {
  const zeldaUrl = `${getZeldaBaseUrl()}/admin/v2/learning/resources/lessons/${
    block.lesson_id
  }?via_record_id=${bootcampId}&via_resource_class=Avo%3A%3AResources%3A%3ACourse`;

  return (
    <div className="edit-in-zelda-placeholder">
      This block isn&apos;t editable in this view. Please&nbsp;
      <a href={zeldaUrl} target="_blank" rel="noopener noreferrer">
        edit it in Zelda
      </a>
      .
    </div>
  );
};

BlockEditInZeldaPlaceholder.propTypes = {
  block: PropTypes.object.isRequired,
  bootcampId: PropTypes.string,
};

export default BlockEditInZeldaPlaceholder;
